module.exports = __webpack_public_path__ + "static/media/1-7.3a8128de.png";